var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8 20.4H1.2C0.537608 20.4 0 20.9376 0 21.6C0 22.2624 0.537608 22.8 1.2 22.8H22.8C23.4624 22.8 24 22.2624 24 21.5999C24 20.9376 23.4624 20.4 22.8 20.4ZM1.2 3.59995H22.8C23.4624 3.59995 24 3.06238 24 2.39995C24 1.73752 23.4624 1.19995 22.8 1.19995H1.2C0.537608 1.19999 0 1.73756 0 2.39999C0 3.06238 0.537608 3.59995 1.2 3.59995ZM22.8 10.8H1.2C0.537608 10.8 0 11.3376 0 12C0 12.6624 0.537608 13.2 1.2 13.2H22.8C23.4624 13.2 24 12.6624 24 12C24 11.3376 23.4624 10.8 22.8 10.8Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.64a045779174d2d500cd7af7d8899ce7.svg";
export { ForwardRef as ReactComponent };